import React from "react";
import { Input } from "../../../design/input";
import { Select } from "../../../design/select";
import { Button } from "../../../design/button";
import { XMarkIcon } from "@heroicons/react/20/solid";

type FilterStatus = "all" | "pending" | "approved" | "completed";

interface ReportFiltersProps {
  searchTerm: string;
  statusFilter: FilterStatus;
  startDateFilter: string;
  endDateFilter: string;
  onSearchChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onStatusChange: (e: React.ChangeEvent<HTMLSelectElement>) => void;
  onStartDateChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onEndDateChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onClearFilters: () => void;
  hasActiveFilters: boolean;
}

const ReportFilters: React.FC<ReportFiltersProps> = ({
  searchTerm,
  statusFilter,
  startDateFilter,
  endDateFilter,
  onSearchChange,
  onStatusChange,
  onStartDateChange,
  onEndDateChange,
  onClearFilters,
  hasActiveFilters,
}) => {
  return (
    <div className="flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
      {/* Search and Filters */}
      <div className="flex flex-col gap-3 sm:flex-row sm:items-center">
        {/* Search Input */}
        <div className="relative flex-1 sm:max-w-sm">
          <Input
            type="search"
            placeholder="Search by monitor or case..."
            value={searchTerm}
            onChange={onSearchChange}
          />
        </div>

        {/* Status Filter */}
        <Select
          name="status"
          value={statusFilter}
          onChange={onStatusChange}
          className="sm:w-40"
        >
          <option value="all">All Status</option>
          <option value="pending">Pending</option>
          <option value="approved">Approved</option>
          <option value="completed">Completed</option>
        </Select>

        {/* Start Date Filter */}
        <Input
          type="date"
          placeholder="Start Date"
          value={startDateFilter}
          onChange={onStartDateChange}
          className="sm:w-40"
        />

        {/* End Date Filter */}
        <Input
          type="date"
          placeholder="End Date"
          value={endDateFilter}
          onChange={onEndDateChange}
          className="sm:w-40"
        />
      </div>

      {/* Clear Filters Button */}
      {hasActiveFilters && (
        <Button
          plain
          onClick={onClearFilters}
          className="flex items-center gap-2 text-zinc-600 hover:text-zinc-800 dark:text-zinc-400 dark:hover:text-zinc-200"
        >
          <XMarkIcon className="w-4 h-4" />
          Clear filters
        </Button>
      )}
    </div>
  );
};

export default ReportFilters; 